// @flow
import { SET_PERMISSION } from 'actions/locationPermission';

export type Permission = 'granted' | 'denied' | 'prompt' | 'initneeded';

export type State = {|
  +permission: Permission,
|};

const INITIAL_STATE: State = {
  permission: 'initneeded',
};

export default function reduce(
  state: State = INITIAL_STATE,
  { type, ...payload }
) {
  switch (type) {
    case SET_PERMISSION: {
      const { permission } = payload;
      return {
        ...state,
        permission,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/locationPermission.js